(function($) {
  'use strict';

  function initVisitTemplates() {
    var $form = $("form.prevent_without_secret_word");
    var $container = $(".js-consultations-container");
    var $templateSelect = $(".js-visit-template-select");
    var addConsultationLink = document.querySelector(".js-add-consultation");
    var blankPartial = addConsultationLink ? addConsultationLink.getAttribute("data-partial") : "";
    var clinicId = $form.data("clinic-id");

    if (!$templateSelect.length) return;

    // Reset select to blank on fresh page loads (not when controller pre-populated from template)
    var hasPrepopulatedTemplateConsults = $container.find(".js-template-consult").length > 0;
    if (!hasPrepopulatedTemplateConsults) {
      $templateSelect.val("");
    }

    function clearNewConsults() {
      $container.children(".js-consultation-container.js-template-consult").each(function() {
        var $el = $(this);
        if ($el.find(".js-consult-id").length > 0) {
          $el.remove();
        }
      });
    }

    // Remove new (non-persisted) ad-hoc consults when a template is selected,
    // so the template's consults replace the default blank consult rather than
    // sitting alongside it (which would submit a blank chief_complaint).
    function clearAdHocConsults() {
      $container.children(".js-consultation-container").not(".js-template-consult").each(function() {
        var $el = $(this);
        // Only remove new (unpersisted) consults; persisted consults on edit
        // views do not render the .js-consult-id hidden field.
        if ($el.find(".js-consult-id").length > 0) {
          $el.remove();
        }
      });
    }

    // Re-add a single blank ad-hoc consult when the template is cleared back
    // to "None" so the form is not left empty.
    function ensureAtLeastOneConsult() {
      if ($container.children(".js-consultation-container").length > 0) return;
      if (!blankPartial) return;

      var newId = new Date().getTime() + Math.floor(Math.random() * 1000);
      var content = blankPartial.replace(/consult_id_placeholder/g, newId);
      $container.append(content);

      if (window.initDatepickers) {
        window.initDatepickers($, $container.children(".js-consultation-container").last());
      }
    }

    function addConsultFromTemplate(entry) {
      if (!blankPartial) return;
      var newId = new Date().getTime() + Math.floor(Math.random() * 1000);
      var content = blankPartial;
      content = content.replace(/consult_id_placeholder/g, newId);

      $container.append(content);
      var $newConsult = $container.children(".js-consultation-container").last();

      // Set chief complaint
      $newConsult.find("textarea[name*='chief_complaint']").val(entry.chief_complaint);

      // Set is_from_template to true
      $newConsult.find(".js-consult-from-template").val("true");
      $newConsult.addClass("js-template-consult");

      // Set is_required and specialization_id hidden fields
      $newConsult.find("input[name*='is_required']").val(entry.is_required ? "1" : "0");
      $newConsult.find("input[name*='specialization_id']").val(entry.specialization_id || "");

      // Replace Ad-hoc badge with From Template badge (only in the card header)
      var $header = $newConsult.children(".js-consult-header");
      $header.find(".js-consult-source-badge").replaceWith(
        '<span class="ml-2 inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800">From Template</span>'
      );

      // Handle required vs optional
      $newConsult.attr("data-is-required", entry.is_required);
      $newConsult.attr("data-specialization-id", entry.specialization_id || "");

      if (entry.is_required) {
        $newConsult.addClass("js-required-consult");
        // Hide delete button
        $newConsult.find(".js-delete-consultation").remove();
        // Add Required badge (only in the card header, not other h4s like HMO)
        var $headerTitle = $header.find("h4");
        if ($headerTitle.find(".bg-amber-100").length === 0) {
          $headerTitle.append('<span class="ml-2 inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">Required</span>');
        }
      }

      if (window.initDatepickers) {
        window.initDatepickers($, $newConsult);
      }
    }

    $templateSelect.on("change", function() {
      var templateId = $(this).val();
      if (!templateId) {
        clearNewConsults();
        ensureAtLeastOneConsult();
        return;
      }

      $.ajax({
        url: "/api/visit_templates/" + templateId + "/consult_entries",
        data: { clinic_id: clinicId },
        dataType: "json",
        success: function(response) {
          clearNewConsults();
          clearAdHocConsults();
          if (response.consult_entries) {
            response.consult_entries.forEach(function(entry) {
              addConsultFromTemplate(entry);
            });
          }
        },
        error: function() {
          alert("Failed to load template consults. Please try again.");
        }
      });
    });
  }

  $(document).ready(initVisitTemplates);
  $(document).on('page:load', initVisitTemplates);
})(jQuery);
